module.exports = __webpack_public_path__ + "img/mqttx-dark.652b88e5.png";